<template>
  <el-row :gutter="20">
    <nav>
      <ul>
        <li><a style="font-size:14px;font-weight:bold;color:#FF4949;" href="/#/admin/addenterprisename">添加企业全称对应关系</a></li>
        <li><a href="javascript:;" @click="logout()">退出</a></li>
      </ul>
    </nav>
    <header class="header">
      <img src="../assets/zf-logo.png" width="100">
      <h1>中国房地产测评系列榜单后台</h1>
    </header>
    <div class="main">
    <el-col :span="6" v-for="(o,index) in data" :key="index" >
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <el-button type="text" @click="goNext(o.id,o.issub)">{{o.name}}</el-button>
              <el-tooltip content="有子榜单" placement="bottom"  v-if="o.issub">
                <el-button>
                  <i class="el-icon-caret-bottom"></i>
                </el-button>
              </el-tooltip>
            </el-card>
          </div>
    </el-col>
    <el-col :span="24">
      <div class="grid-content bg-purple">
           <el-button type="primary" @click="showdialogFormaddAward">添加奖项</el-button>
      </div>

      <el-dialog title="奖项设置" :visible.sync="dialogFormaddAward">
            <el-form :model="form">
              <el-form-item label="获奖名称" :label-width="formLabelWidth">
                <el-col :span="20">
                <el-input v-model="form.name" placeholder="请输入奖项名称" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormaddAward = false">取 消</el-button>
              <el-button type="primary" @click="addAwards">添 加</el-button>
            </div>
          </el-dialog>
    </el-col>
    <el-col :span="12"><div class="grid-content bg-purple-light"></div></el-col>
    </div>
  </el-row>
</template>
<script>
export default {
  name: 'adminlist',
  data () {
   return {
      msg: '',
      form: {
        name: '',
        preId: 0
      },
      dialogFormaddAward: false,
      formLabelWidth: '120px',
      data: []
    }
  },
  mounted: function(){
    var that = this;
    that.setHeight();
    $(window).resize(function(){
      that.setHeight();
    });
      this.$nextTick(function () {
          this.$http.get('/api/awards/awards_list').then(
                response => {
                  for(var i = 0; i < response.body.length; i++){
                    if(response.body[i].preId == 0){
                      this.data.push(response.body[i]);
                    }
                  }
                },
                response => {
                  console.log('failed');
                }
              )
        })

  },
  methods: {
    goNext (id,issub) {
        this.$router.push({ name: 'adminsublist', params: {id: id}});
        
    },
    showdialogFormaddAward(){
      this.dialogFormaddAward = true;
    },
    addAwards(){
      this.$http.post('/api/awards/addawards', this.form).then(  //添加奖项
          (response) => {
             console.log(response);
             if(response.ok){
              this.$message({
                      showClose: true,
                      message: '恭喜你，添加成功',
                      type: 'success'
                    });
                this.data.push(response.body.data);
                this.dialogFormaddAward = false;
             }
          },
          (response) => {
             console.log(response);
          }
        )
    },
    setHeight (){
      var height = window.innerHeight - 370;
      $('.main').css('min-height', height + 'px');
    },
    logout(){
      this.$store.dispatch('Logout').then(() => {
          this.$router.push({ path: '/login' });
      }).catch(err => {
          this.$message.error(err);
      });
    }
  }
}


</script>



// WEBPACK FOOTER //
// src/components/AdminList.vue